export enum FirstOnboardingScreenState {
  CURRENT = "current",
  HAS_TEXT = "hasText",
  NO_TEXT = "noText",
}
